<template>
  <div class="home-section">
    <div class="container text-center">
      <div class="lostSailor-logo">
        <img src="/lostsailor/images/lost.png " alt="" />
      </div>
      <div class="home-content">
        <section class="section">
          <div class="inventory-page">
            <router-link to="/inventory">
              <div class="inventory-page_icon">
                <img src="images/inventory-icon.png" alt="" class="" />
              </div>
              <h1 class="inventory-page_title">Inventory</h1>
            </router-link>
          </div>
          <div class="marketplace-section ml-5">
            <div class="inventory-page">
              <router-link to="/marketplace">
                <div class="inventory-page_icon">
                  <img src="images/market-icon.png" alt="" class="" />
                </div>
                <h1 class="inventory-page_title mt-3">Marketplace</h1>
              </router-link>
            </div>
          </div>
          <div class="staking-section ml-5">
            <div class="inventory-page">
              <router-link to="/staking">
                <div class="inventory-page_icon">
                  <img src="images/staking.png" alt="" class="" />
                </div>
                <h1 class="inventory-page_title mt-3">Shipyard</h1>
              </router-link>
            </div>
          </div>
        </section>
        <section class="btn-wrapper">
          <div class="btn-banner button">
            <router-link to="/continent">
              <img src="images/old-banner.png" alt="" />
              <h3 class="btn-inner_title">discover</h3>
            </router-link>
          </div>
          <div class="battle-button button position-relative">
            <router-link to="/battle">
              <img src="images/old-banner.png" alt="" class="img-fluid" />
              <h3 class="btn-inner_title">battle</h3>
            </router-link>
          </div>
        </section>
      </div>
    </div>
    <section class="footer-section">
      <div class="leaderBoard">
        <router-link to="/leaderBoard">
          <img src="images/leaderboard.png" alt="" />
          <p>leaderboard</p>
        </router-link>
      </div>
      <div class="logout">
        <a href="/login" class="btn btn-primary btn-sm btn-black">log out</a>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "home",
};
</script>

<style scoped>
.btn-wrapper {
  display: flex;
  width: 60%;
  margin: auto;
}
.btn-wrapper .button {
  width: 350px;
  margin: 3rem auto;
}
.btn-wrapper .button .btn-inner_title {
  position: absolute;
  top: 26px;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: 2.5rem;
  text-transform: uppercase;
  font-weight: bold;
  color: var(--mainBlack);
}

/* .btn-wrapper .button .dis-title {
 
}
.btn-wrapper .button .battle-title {
  top: 22px;
  left: 0;
} */
.btn-wrapper .button .btn-inner_title:hover {
  color: #d2915e;
  transition: color 0.4s ease-in-out;
}
</style>